module.exports = __webpack_public_path__ + "img/Intro_text02_predict.c9fc2b58.png";